import React from 'react'
import {Section} from "./content"
import Collapsable from "./collapsable";
import {SectionTitle, SectionDescription} from './section';
import {Spacer, EllipsesSpacer} from "./spacer"
import {cssOnlyDesktop} from "../styles/utils"

export const Faq = ({className, mentionGas = true}) => <>
  <div className={className}/>
  <EllipsesSpacer/>
  <Section>
    <div css={[cssOnlyDesktop('padding-left: 201px; padding-right: 201px;')]}>
      <SectionTitle>Vuoi vederci chiaro?</SectionTitle>
      <SectionDescription maxWidth={696}>Qui puoi trovare le nostre risposte alle domande più frequenti. Per altri dubbi
        puoi consultare la sezione FAQ o contattarci in chat.</SectionDescription>
      <Spacer size={32}/>
      <Collapsable
        texts={[
          {
            content: (
              <p className={''}>
                Scarica l’App su Google Play o AppStore, segui i passaggi
                e in soli 5 minuti avrai già finito.
                <br/>
                A tutta la burocrazia penseremo noi, garantito!
                <br/>
                Avrai bisogno solo di 2 cose: una vecchia bolletta e un
                metodo di pagamento (IBAN o carta)
              </p>
            ),
            title: <>Come posso passare le mie utenze luce {mentionGas && <>e gas</>} a Tate?</>
          },
          {
            content: (
              <p className={''}>
                Assolutamente no.
                <br/>
                Il cambio di fornitore è un processo totalmente digitale,
                quindi non c’è il minimo rischio di restare senza
                corrente{mentionGas && <>/gas</>} o di riscontrare interruzioni del servizio.
              </p>
            ),
            title: <>Rischio di rimanere senza corrente {mentionGas && <>o gas</>} durante il cambio fornitore?</>
          },
          {
            content: (
              <p className={''}>
                Passando a Tate non ti impegni per una durata minima.
                <br/>
                Sei uno di noi fino a quando vuoi, senza obblighi, ma solo
                se sei soddisfatto del servizio.
                <br/>
                Inoltre attivare o recedere un contratto con Tate (se stai
                passando la tua fornitura ad un altro fornitore) non ha
                alcun costo e non lo avrà mai.
              </p>
            ),
            title: <>Quanto dura un contratto luce {mentionGas && <>e gas</>} con Tate?</>
          },
          {
            content: (
              <p className={''}>
                Le bollette Tate sono mensili. Secondo noi la cadenza
                mensile è la più semplice, trasparente e facile da gestire
                finanziariamente.
                <br/>
                Intorno alla metà del mese successivo a cui si riferisce
                il consumo ti invieremo una nuova fattura.
                <br/>
                La bolletta Tate viene inviata per mail ed è consultabile
                anche dall’app.
              </p>
            ),
            title: 'Con quale frequenza arriverà la bolletta?'
          }]}/>
    </div>
  </Section>
</>
